<template>
  <div class="social-bar" :class="{ visible: scrolled }">
    <div class="icon-holder rounded-left">
      <ClientOnly>
        <div class="">
          <a
            rel="nofollow noopener noreferrer"
            target="_blank"
            class="res-text fixed transform -translate-y-1/2 -translate-x-12 heebo_text bg-cloud-color text-white p-2 px-8 cursor-pointer z-50 hover:bg-opacity-90 transition ease-in-out duration-300"
            href="https://salamis-bay-conti-hotel.hotelrunner.com/bv3/search"
            alt="Reservation Button"
          >
            {{ $t("reservation") }}
          </a>
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      scrolled: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 80;
    },
  },
};
</script>

<style scoped>
.res-text {
  margin-inline: 5px;
  text-decoration: none;
  font-size: 25px;
  color: white !important;
}
.social-bar {
  position: fixed;
  left: 0;
  bottom: 55%;
  z-index: 45;
  opacity: 0;
  pointer-events: none;
  transform: translateX(-100%);
  transition: opacity 300ms ease, transform 300ms ease;
}
.social-bar.visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
}
.icon-holder {
  background-color: #042333;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border-top: 2px solid #e7bb7f;
  border-right: 2px solid #e7bb7f;
  border-bottom: 2px solid #e7bb7f;
}

@media (max-width: 768px) {
  .social-bar {
    bottom: 65%;
  }
}
</style>
